import { AutogenModelAllPayees, AutogenRowAllPayees } from "./autogen/AutogenModelAllPayees";

export class ModelAllPayees extends AutogenModelAllPayees<RowAllPayees> {
	constructor() {
		super(RowAllPayees);
	}
}

export class RowAllPayees extends AutogenRowAllPayees {
}